import ROLES_NUM from '../../core/auth/roles.enum';

export default [
    {
        path: '/root-admin',
        name: 'root-admin-dashboard',
        redirect: '/root-admin/tenants',
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    }, 
    {
        path: '/root-admin/tenants',
        name: 'root-admin-tenants',
        component: () =>  import('@/root-admin/Tenants'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/client-leads',
        name: 'root-admin-client-leads',
        component: () =>  import('@/root-admin/ClientLeads'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/signups',
        name: 'root-admin-signups',
        component: () =>  import('@/root-admin/Signups'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/coupons',
        name: 'root-admin-coupons',
        component: () =>  import('@/root-admin/Coupons'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/support',
        name: 'root-admin-support',
        component: () =>  import('@/root-admin/Support'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        //הכרזות: popups the root admin writes (pasted HTML) and sends to all / picked / filtered accounts
        path: '/root-admin/announcements',
        name: 'root-admin-announcements',
        component: () =>  import('@/root-admin/Announcements'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        //חתימה דיגיטלית: documents the root admin uploads (pdf / google docs link), marks and sends to be signed
        path: '/root-admin/esign',
        name: 'root-admin-esign',
        component: () =>  import('@/root-admin/ESign'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/esign/:id',
        name: 'root-admin-esign-document',
        component: () =>  import('@/root-admin/ESignDocument'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
    {
        path: '/root-admin/ai',
        name: 'root-admin-ai',
        component: () =>  import('@/root-admin/AiUsage'),
        meta: {
            requiresAuth: true,
            userInRole: [ROLES_NUM.Admin],
            matchHeight: true
        }
    },
]